import AccordionItemPrimary from "../../common/accordion-item/accordion-item-primary/accordion-item-primary";
import { getAssetUrl } from "../../../api/api";
import type { TTenderhubReviewsSection } from "../../../types/tenderhub";

type Props = {
  reviewsSection?: TTenderhubReviewsSection | null;
};

const TenderhubReviewsSection = ({ reviewsSection }: Props) => {
  const tyLetters = reviewsSection?.tyLetters ?? [];
  const reviews = reviewsSection?.reviews ?? [];

  return (
    <AccordionItemPrimary title="отзыв о работе и благодарственные письма">
      <div>Благодарственные письма</div>
      <ul className="tenderhub-content-list__list">
        {tyLetters.map((item) => {
          const href = item.file?.url ? getAssetUrl(item.file.url) : "";
          return (
            <li key={item.id}>
              {href ? (
                <a href={href}  target="_blank" rel="noreferrer" className="link">
                  {item.title}
                </a>
              ) : (
                <span className="link">{item.title}</span>
              )}
            </li>
          );
        })}
      </ul>

      <div>Отзывы по работе</div>
      <ul className="tenderhub-content-list__list">
        {reviews.map((item) => {
          const href = item.file?.url ? getAssetUrl(item.file.url) : "";
          return (
            <li key={item.id}>
              {href ? (
                <a href={href} download={item.title} className="link">
                  {item.title}
                </a>
              ) : (
                <span className="link">{item.title}</span>
              )}
            </li>
          );
        })}
      </ul>
    </AccordionItemPrimary>
  );
};

export default TenderhubReviewsSection;

